<template>
  <div class="container">
    <div class="tabBar" v-if="tabBarConfig.length > 1">
      <div
        class="tabItem"
        v-for="tabBarItem in tabBarConfig"
        :class="{ active: currentActiveTabId === tabBarItem.key }"
        :key="tabBarItem.key"
        @click="handleTabBarClick(tabBarItem.key)"
      >
        {{ tabBarItem.title }}
      </div>
    </div>
    <TabContainer :value="currentActiveTabId" class="tabContainer">
      <TabContainerItem
        :id="tabBarItem.key"
        :key="tabBarItem.key"
        v-for="tabBarItem in tabBarConfig"
      >
        <component :is="tabBarItem.contentComp"></component>
      </TabContainerItem>
    </TabContainer>
  </div>
</template>

<script>
import { TabContainer, TabContainerItem } from 'mint-ui';
import AwardsList from '../components/myAwards/AwardsList';
import CashPack from '../components/myAwards/CashPack';
import { mapActions, mapMutations, mapState } from 'vuex';
import { TAB_REWARD_TYPE } from '../constants';
import store from '../myAwardsStore';
import rootStore from '@/store';
import { getUrlParam } from '@/utils';

const TabBarComponentBook = {
  [TAB_REWARD_TYPE.AWARDS]: {
    key: 'awards',
    contentComp: AwardsList
  },
  [TAB_REWARD_TYPE.CASH_PACK]: {
    key: 'cashPack',
    contentComp: CashPack
  }
};

export default {
  components: {
    TabContainer,
    TabContainerItem,
    AwardsList,
    CashPack
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app/myAwards', {
      currentActiveTabId: state => state.currentActiveTabId,
      tabConfig: state => state.tabConfig
    }),
    ...mapState('app/lottery', {
      actData: state => state.actData
    }),
    tabBarConfig() {
      return this.tabConfig.map(tabObj => {
        return {
          ...tabObj,
          ...TabBarComponentBook[tabObj.rewardType]
        };
      });
    }
  },
  beforeDestroy() {
    rootStore.unregisterModule(['app', 'myAwards'], store);
  },
  created() {
    rootStore.registerModule(['app', 'myAwards'], store);
    const currentTab = getUrlParam('currentTab');
    let switchTabKey = currentTab ? currentTab : 'awards';
    this.initTab(switchTabKey);
    this.switchTab(switchTabKey);
  },
  methods: {
    ...mapMutations('app/myAwards', ['switchTab']),
    ...mapActions('app/myAwards', [
      'getTabConfig',
      'getAwardsList',
      'getCashPackData'
    ]),
    ...mapActions('app/lottery', ['getActData']),
    handleTabBarClick(key) {
      this.switchTab(key);
      switch (key) {
        case 'awards':
          this.getAwardsList();
          break;
        case 'cashPack':
          this.getCashPackData();
          break;
      }
    },
    async initTab(key) {
      await this.getPageInfo();
      this.getTabConfig(key);
    },
    async getPageInfo() {
      const code = getUrlParam('code');
      console.log(this.actData.metaInfo, 'this.actData.metaInfo');
      if (!this.actData.metaInfo) {
        try {
          await this.getActData(code);
        } catch (error) {
          this.$hll.toast(error && error.msg);
          return;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: #f3f4f5;
}
.tabBar {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: space-between;

  &:before,
  &:after {
    content: '';
    display: block;
  }

  .tabItem {
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: normal;
    font-size: 30px;
    color: #000;

    &.active {
      color: #ff6600;
      border-bottom: 4px solid #ff6600;
    }
  }
}

.tabContainer {
  width: 100%;
  height: calc(100vh - 80px);
  overflow-y: auto;
}
</style>
